import { Box, Button, Menu, Typography } from '@mui/material';

import './NotificationsOverview.scss';

interface NotificationItemData {
  id: number;
  title: string;
  time: string;
  color: 'red' | 'blue';
}

const notifications: NotificationItemData[] = [
  { id: 1, title: 'ULD AKE60402AA temperature alert', time: '2 hours ago', color: 'red' },
  { id: 2, title: 'Visit completed', time: '5 hours ago', color: 'blue' },
  { id: 3, title: 'Low battery alert', time: 'Yesterday', color: 'red' },
];

interface NotificationsOverviewProps {
  anchorEl: null | HTMLElement;
  open: boolean;
  onClose: () => void;
}

const NotificationsOverview = ({ anchorEl, open, onClose }: NotificationsOverviewProps) => {
  return (
    <Menu
      id='notifications-overview-menu'
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      slotProps={{
        paper: {
          className: 'notifications-overview__panel',
        },
      }}
    >
      <Box className='notifications-overview'>
        <Box className='notifications-overview__header'>
          <Typography className='notifications-overview__title'>Notifications</Typography>
          <Box component='span' className='notifications-overview__badge'>
            3 Unread
          </Box>
        </Box>

        <Box className='notifications-overview__list'>
          {notifications.map((notification) => (
            <Box key={notification.id} className='notifications-overview__item'>
              <Box className={`notifications-overview__dot notifications-overview__dot--${notification.color}`} />
              <Typography className='notifications-overview__text'>{notification.title}</Typography>
              <Typography className='notifications-overview__time'>{notification.time}</Typography>
            </Box>
          ))}
        </Box>

        <Box className='notifications-overview__footer'>
          <Button className='notifications-overview__button' onClick={onClose}>
            View All Notifications
          </Button>
        </Box>
      </Box>
    </Menu>
  );
};

export default NotificationsOverview;
